import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BeneficiariService } from '../beneficiari.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import {
  IBeneficiarInfo,
  IBeneficiarInfoType1,
} from '../beneficiari.interface';

@Component({
  selector: 'app-info-beneficiar',
  templateUrl: './info-beneficiar.component.html',
  styleUrls: ['./info-beneficiar.component.scss'],
})
export class InfoBeneficiarComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;
  beneficiar!: IBeneficiarInfoType1;

  token!: string;
  isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IBeneficiarInfo,
    private dialogRef: MatDialogRef<InfoBeneficiarComponent>,
    private beneficiariService: BeneficiariService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
    console.log(this.data);

    this.beneficiar = this.data;
    console.log(this.beneficiar);
  }
  ngOnInit(): void {
    this.getClientDetails(this.data.id_cetatean);
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.beneficiariService.setToken(token);
    });
  }

  closeDialog() {
    this.dialogRef ?.close({
      success: false,
    });
  }

  getClientDetails(beneficiarId: number) {
    this.beneficiariService.getBeneficiarById(beneficiarId);
  }

  isPF() {
    return this.beneficiar.beneficiar_type == '1';
  }

  isPJ() {
    return this.beneficiar.beneficiar_type == '2';
  }
}
